export const EDIT_MDT_CHECKS_CLAIM = "CanEditMdtChecks";
